export const USER_LOGGED_IN ="USER_LOGGED_IN";
export const USER_LOGGED_OUT ="USER_LOGGED_OUT";
export const USER_PROFILE_IMG ="USER_PROFILE_IMG";
